import React from "react";
import { PropertyListing } from "@/components";
import "./AgentTrackRecord.scss";

// Dates arrive as UTC timestamps; format in UTC so a 1st-of-month date does not
// show as the previous month in US time zones.
const monthYear = (value) => {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("en-US", { month: "short", year: "numeric", timeZone: "UTC" });
};

export const activeRange = (start, end) => {
  const from = monthYear(start);
  const to = monthYear(end);
  if (!from) return null;
  if (!to || from === to) return from;
  const [fromMonth, fromYear] = from.split(" ");
  const [toMonth, toYear] = to.split(" ");
  return fromYear === toYear ? `${fromMonth} to ${toMonth} ${toYear}` : `${from} to ${to}`;
};

export const whenOf = (wantAd) => {
  const boughtOn = monthYear(wantAd.EndedOn);
  if (wantAd.Bought && boughtOn) return `Bought ${boughtOn}`;
  const range = activeRange(wantAd.PublishedOn, wantAd.EndedOn);
  return range ? `Active ${range}` : null;
};

export const cardOf = (wantAd, agent = {}) => ({
  Want_ad_Id: wantAd.Want_ad_Id,
  slug: wantAd.slug,
  Title_Text: wantAd.Title_Text,
  Budget_mn: wantAd.Budget_mn,
  Budget_mx: wantAd.Budget_mx,
  Bedrooms: wantAd.Bedrooms,
  Bathrooms: wantAd.Bathrooms,
  Sqft_mn: wantAd.Sqft_mn,
  Sqft_mx: wantAd.Sqft_mx,
  AdType: 1,
  Latitude: wantAd.Latitude,
  Longitude: wantAd.Longitude,
  mapRadius: wantAd.IsZipCodeBased ? null : wantAd.Radius,
  mapImageUrl: wantAd.Location_Img || undefined,
  City: wantAd.City,
  State: wantAd.State,
  Location: !wantAd.IsZipCodeBased && wantAd.Radius && wantAd.City ? wantAd.City : null,
  CreatedBy: agent.UserId,
  Is_Agent_Created: 1,
  userFirstName: agent.FirstName,
  userLastName: agent.LastName,
  userAvatar: agent.isPremiumAgent ? agent.Img : null,
  userCompany: agent.Company,
  isAgentPremium: agent.isPremiumAgent,
});

const AgentTrackRecord = ({ history, agent, onOpen }) => {
  const past = history?.past || [];
  if (!past.length) return null;

  return (
    <section className="agent-track">
      <h2 className="agent-bio-section-title">Past Buyer Want&#8209;Listings</h2>
      <div className="agent-track__list">
        {past.map((wantAd) => (
          <PropertyListing
            key={wantAd.Want_ad_Id}
            list={cardOf(wantAd, agent)}
            results={[]}
            readOnly
            tileLabel={wantAd.Bought ? "Bought" : "Past"}
            note={whenOf(wantAd)}
            handleFavoriteOrUnfavoriteWantAd={() => {}}
            handleWantAdItemClick={(wantAdId, slug) => onOpen && onOpen(slug)}
            onChangeText={() => {}}
            onAddClient={() => {}}
          />
        ))}
      </div>
    </section>
  );
};

export default AgentTrackRecord;
